export function getTelegramInitData() {
  const initData = window.Telegram?.WebApp?.initData;
  if (typeof initData === 'string' && initData.length > 0) {
    return initData;
  }

  const params = new URLSearchParams(window.location.hash.substring(1));
  const tgWebAppData = params.get('tgWebAppData');
  if (typeof tgWebAppData === 'string' && tgWebAppData.length > 0) {
    return tgWebAppData;
  }

  return '';
}

export function isTelegramMiniApp() {
  return getTelegramInitData().length > 0;
}
